<template>
  <div>
    <nav-bar></nav-bar>
    <connection-answer v-if="showConnectionAnswer" v-on:closeConnectionView="closeConnectionView" :answer="answer" v-on:saveConnectionData="saveConnectionData"></connection-answer>
    <div class="container intents">
      <div class="section">
        <nav class="breadcrumb" aria-label="breadcrumbs">
          <ul>
            <li><a @click="$router.push('/clients')">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_BREADCRUMB_CHATBOTS') }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents')">{{ clientName }}</a></li>
            <li><a @click="$router.push('/clients/' + client + '/intents/' + intent + '/sentences')">{{ intentName }}</a></li>
            <li v-if="typeAnswer === 0"><a @click="$router.push('/clients/' + client + '/intents/' + intent + '/sentences/' + sentence + '/answers')">{{ sentenceName }}</a></li>
            <li v-if="typeAnswer === 0"><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences/' + sentence + '/answers')">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_BREADCRUMB_ANSWERS') }}</a></li>
            <li v-if="typeAnswer === 1"><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences?tab=common-answers')">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_BREADCRUMB_COMMON_ANSWERS') }}</a></li>
            <li v-if="typeAnswer === 2"><a @click="$router.push('/clients/'+client+'/intents/'+intent+'/sentences?tab=default-answers')">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_BREADCRUMB_DOUBT_ANSWERS') }}</a></li>
            <li class="is-active"><a href="#" aria-current="page">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_BREADCRUMB_NEW_PROMPT') }}</a></li>
          </ul>
        </nav>
        <div class="is-flex-row-center columns">
          <!--     TABS     -->
          <div class="is-flex-row-center column">
            <div class="tabs is-toggle">
              <ul>
                <li :class="{'is-active': isActiveTab('simple')}" @click="showTab('simple')">
                  <a><span>{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_TABS_SIMPLE') }}</span></a>
                </li>
                <li :class="{'is-active': isActiveTab('complex')}" @click="showTab('complex')">
                  <a><span>{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_TABS_COMPLEX') }}</span></a>
                </li>
              </ul>
            </div>
            <a class="connection" v-if="isActiveTab('complex')" @click="toggleConnectionAnswer">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_SET_UP_CONN') }}</a>
          </div>
          <div class="column">
            <div class="tabs is-toggle">
              <ul>
                <li :class="{'is-active': isActiveResponseTab('visible')}" @click="toggleResponseTab('visible')">
                  <a><span>{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_VISIBLE_FOR_USER') }}</span></a>
                </li>
                <li :class="{'is-active': isActiveResponseTab('no-visible')}" @click="toggleResponseTab('no-visible')">
                  <a><span>{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_SYSTEM_INTERNAL') }}</span></a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column pr-2">
            <div class="field">
              <label class="label">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_PROMPT_DESCRIPTION_LABEL') }}</label>
              <div class="control">
                <input type="text" class="is-full-width" v-model="response.promptTitle" />
              </div>
            </div>
            <div class="field">
              <label class="label">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_GPT_PROMPT_LABEL') }}</label>
              <div class="control">
                <textarea class="is-full-width chatgpt" v-bind:placeholder="CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_GPT_PROMPT_PLACEHOLDER')"
                          v-model="response.response"></textarea>
              </div>
              <!--<div  v-for="(payload, index) in payloadsFilesResponses" :key="index" class="is-flex-row-center space-between file-box">
                <div>
                  <span class="icon"><i class="fas fa-file-alt"></i></span>{{ formatFilePayload(payload) }}
                </div>
                <span class="icon cpointer" @click="deleteResponse(index)"><i class="fas fa-times"></i></span>
              </div>-->
            </div>
            <div v-if="showFileSection" class="is-flex-row-center file-section">
              <div class="select">
                <select v-model="filePayload" @change="addFilePayload">
                  <option v-for="(payload, index) in payloadsFilesList" :value="payload" :key="index">{{ payload }}</option>
                </select>
              </div>
              <div class="button is-primary" @click="showAddFile">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_NEW_FILE_BUTTON') }}</div>
            </div>
            <div class="is-flex-row-center space-between buttons">
              <div class="chatgpt-button" @click="addElement(1)">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_PROCESS_ANSWER_BUTTON') }}</div>
              <div class="chatgpt-button" @click="addElement(2)">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_USER_QUESTION_BUTTON') }}</div>
              <div class="chatgpt-button" @click="addElement(3)">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_THEME_BUTTON') }}</div>
              <div class="chatgpt-button" :class="{'is-primary': showFileSection}" @click="showFileSection = !showFileSection">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_DOCUMENT_BUTTON') }}</div>
            </div>
          </div>
          <div class="column">
            <form class="is-flex-column-center">
              <!-- Segun el payload encontrado -->
              <div class="is-flex-row space-between">
                <label class="label"><input type="radio" ref="input-options" name="payload-form" @click="togglePayloadSelected(1)"/> {{ CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_BASED_ON_PAYLOAD_LABEL') }}</label>
                <label v-if="response.promptOptions === 1" class="label">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_EXECUTE_LABEL') }}</label>
              </div>
              <div v-if="response.promptOptions === 1" v-for="(payload, index) in response.optionsList" class="chatgpt-inputs space-between" :key="index">
                <input type="text" class="w-chatgpt" v-bind:placeholder="CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_FOUND_PAYLOAD_GPT_PLACEHOLDER')"
                       v-model="response.optionsList[index]['payloadOption']"/>
                <input type="text" class="w-kdca" v-bind:placeholder="CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_DESTINY_PAYLOAD_KDCA_PLACEHOLDER')"
                       v-model="response.optionsList[index]['payloadDestiny']"/>
                <div class="field has-addons">
                  <p class="control">
                    <a v-if="response.optionsList[index]['ejecutar'] === 0" class="button" style="background-color: var(--is-warning)" @click="toggleExecute(1, 1, index)">
                      <span class="icon"><i class="fas fa-toggle-off"></i></span>
                    </a>
                    <a v-else class="button is-success" @click="toggleExecute(1, 0, index)">
                      <span class="icon"><i class="fas fa-toggle-on"></i></span>
                    </a>
                  </p>
                </div>
              </div>
              <div v-if="response.promptOptions === 1" class="dialog-inputs is-flex-row-center space-between">
                <label class="pright-1">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_IF_PREVIOUS_NOT_FOUND_LABEL') }}</label>
                <input type="text" class="w-kdca"  v-bind:placeholder="CONSTANTS.getCopy('STORECHATGPTPROMPT_INPUT_DESTINY_PAYLOAD_KDCA_PLACEHOLDER')"
                       v-model="response.promptOptionsDefault">
                <div class="field has-addons">
                  <p class="control">
                    <a v-if="response.promptOptionsDefaultEjecutar === 0" class="button" style="background-color: var(--is-warning)" @click="toggleExecute(2, 1)">
                      <span class="icon"><i class="fas fa-toggle-off"></i></span>
                    </a>
                    <a v-else class="button is-success" @click="toggleExecute(2, 0)">
                      <span class="icon"><i class="fas fa-toggle-on"></i></span>
                    </a>
                  </p>
                </div>
              </div>
              <!-- Intependientemente -->
              <div class="is-flex-row space-between">
                <label class="label"><input type="radio" ref="input-independent" name="payload-form" @click="togglePayloadSelected(2)"/> {{ CONSTANTS.getCopy('STORECHATGPTPROMPT_GPT_PROMPT_ANSWER_LABEL') }}</label>
                <label class="label" v-if="response.promptIndepent === 1">{{CONSTANTS.getCopy('STORECHATGPTPROMPT_GPT_PROMPT_EXECUTE_LABEL')}}</label>
              </div>
              <div class="is-flex-row-center space-between" v-if="response.promptIndepent === 1">
                <input type="text" class="dialog-inputs w-chatgpt" placeholder="Payload destino (KDCA)" v-model="response.promptIndepentDefault">
                <div class="field has-addons">
                  <p class="control">
                    <a v-if="response.promptIndepentDefaultEjecutar === 0" class="button" style="background-color: var(--is-warning)" @click="toggleExecute(3, 1)">
                      <span class="icon"><i class="fas fa-toggle-off"></i></span>
                    </a>
                    <a v-else class="button is-success" @click="toggleExecute(3, 0)">
                      <span class="icon"><i class="fas fa-toggle-on"></i></span>
                    </a>
                  </p>
                </div>
              </div>
            </form>
          </div>
          <div v-if="!showConnectionAnswer" class="is-right-bottom">
            <div class="button is-primary" @click="storePrompt">
              <span class="icon"><i class="fas fa-save fa-lg"></i></span>
              <span class="is-capitalized">{{ CONSTANTS.getCopy('STORECHATGPTPROMPT_SAVE_BUTTON') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import ConnectionAnswer from './ConnectionAnswer'
import AnswerTypes from '../../../../lib/AnswerTypes'
import Strings from '../../../../lib/Strings'
export default {
  name: 'StoreChatGptPrompt',
  components: { ConnectionAnswer },
  data () {
    return {
      response: {
        promptTitle: '',
        response: '',
        idIntent: 0,
        idDictionary: 0,
        promptVisible: 1,
        promptIndepent: 0,
        promptIndepentDefault: null,
        promptOptions: 0,
        promptOptionsDefault: null,
        promptOptionsDefaultEjecutar: 1,
        promptIndepentDefaultEjecutar: 1,
        optionsList: new Array(9),
        type: null
      },
      filePayload: null,
      typeAnswer: 0,
      intent: this.$route.params.intent,
      sentence: null,
      client: this.$route.params.client,
      clientName: 'Chatbot',
      intentName: 'Intención',
      activeTab: 'simple',
      showConnectionAnswer: false,
      showFileSection: false,
      payloadsFilesResponses: [],
      payloadsFilesList: null,
      activeResponseTab: 'visible',
      sentenceName: 'Frase'
    }
  },
  created () {
    this.typeAnswer = this.$route.meta.typeAnswer
    switch (this.typeAnswer) {
      case AnswerTypes.COMMON:
        this.response.type = 'G'
        break
      case AnswerTypes.DEFAULT:
        this.response.type = 'D'
        break
      default:
        this.sentence = this.$route.params.sentence
    }
    this.breadcrumbDetails()
    for (let i = 0; i < this.response.optionsList.length; i++) {
      this.response.optionsList[i] = {'payloadOption': null, 'payloadDestiny': null, 'ejecutar': 1}
    }
    this.getFilePayloads()
  },
  methods: {
    addFilePayload () {
      // this.payloadsFilesResponses.push(`{DOC_${this.filePayload}}`)
      this.response.response += `{DOC_${this.filePayload}}`
      this.showFileSection = false
    },
    deleteResponse (index) {
      this.payloadsFilesResponses.splice(index, 1)
    },
    breadcrumbDetails () {
      this.api.post('/ClientById/', {idClient: this.client}).then(response => {
        this.clientName = response.client.name
      })
      this.api.post('/IntentById', {idIntent: this.$route.params.intent}).then(response => {
        this.intentName = response.intent.name
      })
      if (this.typeAnswer === AnswerTypes.SENTENCE) {
        this.api.post('/PhraseById', { idDictionary: this.sentence }).then(response => {
          this.sentenceName = response.phrase.term
        })
      }
    },
    getFilePayloads () {
      this.api.post('/ResponsesFilePayloadList', {idClient: this.client}).then((response) => {
        this.payloadsFilesList = response.payloads
      })
    },
    showAddFile () {
      this.dialog.uploadAnswerFile({typeAnswer: this.response.type}).then(() => {
        this.getFilePayloads()
      })
    },
    showTab (tab) {
      this.activeTab = tab
    },
    toggleResponseTab (tab) {
      this.response.promptVisible = tab === 'visible' ? 1 : 0
      this.activeResponseTab = tab
    },
    isActiveTab (tab) {
      return this.activeTab === tab
    },
    toggleExecute (option, value, position = null) {
      switch (option) {
        case 1:
          this.response.optionsList[position]['ejecutar'] = value
          this.$forceUpdate()
          break
        case 2:
          this.response.promptOptionsDefaultEjecutar = value
          break
        case 3:
          this.response.promptIndepentDefaultEjecutar = value
          break
      }
    },
    isActiveResponseTab (tab) {
      return this.activeResponseTab === tab
    },
    toggleConnectionAnswer () {
      this.showConnectionAnswer = !this.showConnectionAnswer
    },
    closeConnectionView () {
      this.showConnectionAnswer = false
    },
    addElement (type) {
      let text = ''
      switch (type) {
        case 1:
          text = '{RESPUESTA_PROCESO}'
          break
        case 2:
          text = '{PREGUNTA_USUARIO}'
          break
        case 3:
          text = '{TEMATICAS_nombre_tematica}'
          break
      }
      this.response.response += text
    },
    // formatFilePayload (response) {
    //   if (response) {
    //     let payload = response.split('{DOC_')[1]
    //     return payload.split('}')[0]
    //   }
    // },
    togglePayloadSelected (option) {
      if (option === 1) {
        this.response.promptOptions = 1
        this.response.promptIndepent = 0
        this.$refs['input-options'].checked = true
        return
      }
      this.response.promptOptions = 0
      this.response.promptIndepent = 1
      this.$refs['input-independent'].checked = true
    },
    saveConnectionData (data) {
      this.response.method = data.method
      this.response.process = data.process
      this.response.contentType = data.contentType
      this.response.parameters = data.parameters
      if (data.parametersList) this.response.parametersList = data.parametersList
      if (data.responseHelp) this.response.responseHelp = data.responseHelp
      if (data.responseError) this.response.responseError = data.responseError
    },
    storePrompt () {
      let endpoint = '/PromptRegister'
      if (this.activeTab === 'complex') endpoint = '/PromptRegisterProcess'

      let optionsTemp = []
      this.response.optionsList.forEach((element) => {
        if (element['payloadOption'] !== null && element['payloadDestiny'] !== null) optionsTemp.push(element)
      })
      this.response.optionsList = optionsTemp

      this.response.idIntent = this.intent
      if (this.response.type === null && this.sentence) {
        this.response.idDictionary = this.sentence
        this.response.idIntent = 0
      }

      let parametersList = {}
      if (this.response.parametersList) parametersList = Strings.encodeProcessParameters(this.response.parametersList)

      if (this.response.promptOptions === 1) {
        this.response.promptIndepentDefault = null
        this.response.promptIndepentDefaultEjecutar = 0
      }
      if (this.response.promptIndepent === 1) {
        this.response.optionsList = null
        this.response.promptOptionsDefault = null
        this.response.promptOptionsDefaultEjecutar = 0
      }
      this.api.post(endpoint, { ...this.response, parametersList }).then(() => {
        if (this.typeAnswer === AnswerTypes.COMMON) localStorage.setItem('answerView', 'common-answers')
        if (this.typeAnswer === AnswerTypes.DEFAULT) localStorage.setItem('answerView', 'default-answers')
        this.$router.go(-1)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Intents/sentencesAndAnswers/commonAndDefaultAnswers/StoreChatGptPrompt.vue